export default {
  ManageMyVacationsWidget__HEADER_TEXT: "Manage My Vacation",
};
